import { render, staticRenderFns } from "./ReviewModalAddEdit.vue?vue&type=template&id=61e69343&scoped=true&"
import script from "./ReviewModalAddEdit.vue?vue&type=script&lang=js&"
export * from "./ReviewModalAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./ReviewModalAddEdit.vue?vue&type=style&index=0&id=61e69343&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e69343",
  null
  
)

export default component.exports